import React, { useState } from 'react';
import { api } from '../utils/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Mail } from 'lucide-react';

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/api/auth/request-reset', { email });
      setSent(true);
      toast.success('Email de recuperação enviado!');
    } catch (error) {
      toast.error('Erro ao enviar email');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="forgot-password-page">
        <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-lg text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Mail className="h-8 w-8 text-green-600" />
          </div>
          <h2 className="text-2xl font-display font-bold text-primary mb-2">
            Email Enviado!
          </h2>
          <p className="text-text-secondary">
            Se o email existe em nosso sistema, você receberá instruções para redefinir sua senha.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background py-12 px-4" data-testid="forgot-password-page">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-xl shadow-lg">
        <div className="text-center">
          <h2 className="text-3xl font-display font-bold text-primary">Esqueceu a Senha?</h2>
          <p className="mt-2 text-text-secondary">
            Digite seu email para receber instruções de recuperação
          </p>
        </div>
        
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              data-testid="email-input"
            />
          </div>

          <Button
            type="submit"
            className="w-full bg-primary hover:bg-primary/90 rounded-full"
            disabled={loading}
            data-testid="submit-button"
          >
            {loading ? 'Enviando...' : 'Enviar Link de Recuperação'}
          </Button>
        </form>
      </div>
    </div>
  );
};
